import { createServerFn } from "@tanstack/react-start";
import * as db from "@/lib/db.server";
import { requireAuth } from "@/lib/auth/middleware";

/**
 * Server fns for the BookingDialog component. Split out of the component file so
 * the component module does not statically import db.server / auth/middleware at
 * top level (which keeps the `.middleware([requireAuth])` reference alive in the
 * eager client bundle and trips TanStack import-protection). Imported only by the
 * component → resolved into the server bundle.
 */

// Patient-scoped booking insert. Runs on the server (BYPASSRLS pool) gated by
// the Better Auth session. The customer identity (name/email) is taken from the
// authenticated session — NEVER from client-passed values — so a caller can't
// book on someone else's behalf.
export const createBookingFn = createServerFn({ method: "POST" })
  .middleware([requireAuth])
  .inputValidator((d: {
    listingId: string;
    serviceRequested: string;
    appointmentAtISO: string;
    notes: string;
  }) => d)
  .handler(async ({ data, context }) => {
    const u: any = context.user;
    const email: string | undefined = u?.email;
    if (!email) throw new Error("No authenticated email on session");
    const customerName: string =
      (u?.name as string | undefined)?.trim() || email;
    const phone: string | null = (u?.phone as string | undefined) ?? null;
    const inserted = await db.one(
      `INSERT INTO public.appointments
         (listing_id, customer_name, customer_email, customer_phone,
          service_requested, appointment_at, status, source, notes)
       VALUES ($1, $2, $3, $4, $5, $6, 'booked', 'web', $7)
       RETURNING id`,
      [
        data.listingId,
        customerName,
        email,
        phone,
        data.serviceRequested,
        data.appointmentAtISO,
        data.notes,
      ],
    );
    return inserted as { id: string } | null;
  });
